var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.5 1.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.116,19H2.884a1.529,1.529,0,0,1-1.527-1.527V12.214a.763.763,0,1,1,1.527,0v5.259H16.116V12.214a.763.763,0,1,1,1.527,0v5.259A1.529,1.529,0,0,1,16.116,19Zm-.8-9.478A3.658,3.658,0,0,1,12.415,8.1a3.679,3.679,0,0,1-5.821-.015A3.679,3.679,0,0,1,0,5.842V1.527A1.529,1.529,0,0,1,1.527,0H17.473A1.529,1.529,0,0,1,19,1.527V5.842A3.684,3.684,0,0,1,15.321,9.521ZM13.169,1.527V5.842a2.152,2.152,0,1,0,4.3,0V1.527Zm-5.811,0V5.842a2.153,2.153,0,0,0,4.292.242c-.006-.069-.008-.144-.008-.242V1.527Zm-5.831,0V5.842a2.152,2.152,0,1,0,4.3,0V1.527Z",
  transform: "translate(0 0)"
}))));
export default __webpack_public_path__ + "static/media/store-setting.e2f5184a.svg";
export { SvgComponent as ReactComponent };